const firebaseEndpoint = '/api/health/api/firebase'

const getFileUrl = async (path: string, token: string) => {
	if (!path) throw Error('No path provided')
	if (!token) throw Error('No token provided')

	const encoded = encodeURIComponent(path)

	return await fetch(`${firebaseEndpoint}/${encoded}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

export { getFileUrl }
